<div class="update-details-container">
   <div class="detail-information-item">
      <div informationitemlabel class="detail-information-label">Created</div>
      <div Create Date class="detail-information-item-value">
         {{ createDate ? (createDate | date: 'MM/dd/yy hh:mm aa') : 'N/A' }}
      </div>
      <div Create User>
         <span class="detail-information-item-value">
            {{ createUser?.name ? createUser?.name : 'N/A' }}
         </span>
      </div>
   </div>
   <div class="detail-information-item">
      <div informationitemlabel class="detail-information-label">Last Modified</div>
      <div Update Date class="detail-information-item-value">
         {{ updateDate ? (updateDate | date: 'MM/dd/yy hh:mm aa') : 'N/A' }}
      </div>
      <div Update User>
         <span class="detail-information-item-value">
            {{ updateUser?.name ? updateUser?.name : 'N/A' }}
         </span>
      </div>
   </div>
</div>